import { render, staticRenderFns } from "./NameUpdate.vue?vue&type=template&id=112bef66"
import script from "./NameUpdate.vue?vue&type=script&lang=js"
export * from "./NameUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports